import { impactTrackConversion } from '../../../../services/utilities';

export default function signupImpactTracking({ ownerId }) {
  const ownerIdDecoded = atob(ownerId).split(':').pop();
  impactTrackConversion(ownerIdDecoded);
}
